module.exports = __webpack_public_path__ + "./assets/flags/usa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/usa@2x.png
// module id = 71
// module chunks = 0 1